module.exports = __webpack_public_path__ + "img/5e40baf3c78c4928891a507e112124ff-1024.65f613f6.png";